import type { ReceiptTemplate } from '../schema';

export const bookingComTemplate: ReceiptTemplate = {
  id: 'booking-com',
  name: 'Booking.com Receipt',
  brand: 'BOOKING.COM',
  description: 'Booking.com reservation receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'bc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'BOOKING.COM',
        businessNameFontSize: 16,
        addressLines: ['RESERVATION CONFIRMATION'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bc-booking',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'conf', label: 'Conf #:', value: '847291034' },
          { id: 'guest', label: 'Guest:', value: 'John Doe' },
        ],
        column2: [
          { id: 'in', label: 'Check-In:', value: '01/15/2026' },
          { id: 'out', label: 'Check-Out:', value: '01/18/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'bc-property',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PROPERTY:\nGrand Monsterville Hotel\n1200 Dark Avenue\nMonsterville, CA 94608\n\nROOM: Deluxe King (3 nights)', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'bc-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'room', label: 'ROOM TOTAL', value: '450.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAXES & FEES', value: '67.50', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '517.50', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bc-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'bc-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'BOOKING CONFIRMED\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

